import JiraFields from './JiraFields';

export default JiraFields;
